export class HeaderController {
  private el: HTMLDivElement;
  private animationFrameRequestId: number;
  private transitionStartOffset = 50;
  private transitionLength = 128;

  constructor() {
    this.el = document.getElementsByTagName( 'header' )[ 0 ] as HTMLDivElement;
    this.onScroll();

    // register scroll event listener
    document.addEventListener(
      'scroll',
      ( () => {
        if ( this.animationFrameRequestId <= 0 ) {
          this.animationFrameRequestId = window.requestAnimationFrame(
            this.onScroll.bind( this )
          );
        }
      } ).bind( this )
    );
  }

  public onScroll(): void {
    this.el.style.backgroundColor = 'rgba(255,255,255,' + this.getBgOpacityByScrollY() + ')';
    this.animationFrameRequestId = 0;
  }

  private getBgOpacityByScrollY(): string {
    const scrollY = window.pageYOffset;

    if ( scrollY >= this.transitionStartOffset ) {
      const transitionAlpha = ( scrollY - this.transitionStartOffset ) / this.transitionLength;
      return transitionAlpha.toFixed( 2 );
    }
    return '0';
  }
}
